/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NetCDFTimeseriesRain } from "./NetCDFTimeseriesRain";
import {
  NetCDFTimeseriesRainFromJSON,
  NetCDFTimeseriesRainFromJSONTyped,
  NetCDFTimeseriesRainToJSON,
  NetCDFTimeseriesRainToJSONTyped,
} from "./NetCDFTimeseriesRain";

/**
 *
 * @export
 * @interface PaginatedNetCDFTimeseriesRainList
 */
export interface PaginatedNetCDFTimeseriesRainList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<NetCDFTimeseriesRain>;
}

/**
 * Check if a given object implements the PaginatedNetCDFTimeseriesRainList interface.
 */
export function instanceOfPaginatedNetCDFTimeseriesRainList(
  value: object
): value is PaginatedNetCDFTimeseriesRainList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedNetCDFTimeseriesRainListFromJSON(
  json: any
): PaginatedNetCDFTimeseriesRainList {
  return PaginatedNetCDFTimeseriesRainListFromJSONTyped(json, false);
}

export function PaginatedNetCDFTimeseriesRainListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedNetCDFTimeseriesRainList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(NetCDFTimeseriesRainFromJSON),
  };
}

export function PaginatedNetCDFTimeseriesRainListToJSON(
  json: any
): PaginatedNetCDFTimeseriesRainList {
  return PaginatedNetCDFTimeseriesRainListToJSONTyped(json, false);
}

export function PaginatedNetCDFTimeseriesRainListToJSONTyped(
  value?: PaginatedNetCDFTimeseriesRainList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(NetCDFTimeseriesRainToJSON),
  };
}
